import BaseAPI from "@/apis/base/BaseAPI.js";
import BaseAPIConfig from "@/apis/base/BaseAPIConfig.js";
import store from "@/stores/store";

var dataFake = {
  data: {
    Success: true,
    Data: [{ "OrganizationUnitID": 653, "OrganizationUnitCode": "MISA", "OrganizationUnitName": "Hoàng Trung Kiên", "MISACode": "/000/", "ParentID": 0, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 3, "ApplyChild": null, "OrgIDConvert": "f6256c8a-91bd-4232-b52d-845299a6d0cc", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.923+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.398+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.803+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": 5000000 }, { "OrganizationUnitID": 655, "OrganizationUnitCode": "MISA_65", "OrganizationUnitName": "Văn phòng Bắc Ninh", "MISACode": "/000/001/", "ParentID": 653, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 0, "ApplyChild": null, "OrgIDConvert": "6acdacd5-4018-4754-82bd-0ad418ccfbeb", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.924+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.403+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.807+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": null }, { "OrganizationUnitID": 656, "OrganizationUnitCode": "DV70", "OrganizationUnitName": "Đơn vị Kiểm tra", "MISACode": "/000/002/", "ParentID": 653, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 0, "ApplyChild": null, "OrgIDConvert": "f9db2455-6996-4ec8-8608-6e43b235f869", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.924+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.407+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.807+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": null }, { "OrganizationUnitID": 657, "OrganizationUnitCode": "DV47", "OrganizationUnitName": "VP Misa Hải Phòng", "MISACode": "/000/003/", "ParentID": 653, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 0, "ApplyChild": null, "OrgIDConvert": "1d1cfd07-2096-4415-a4a6-faa33e3a7c7a", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.925+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.412+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.807+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": null }, { "OrganizationUnitID": 660, "OrganizationUnitCode": "444", "OrganizationUnitName": "444", "MISACode": "/000/038/", "ParentID": 653, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 0, "ApplyChild": null, "OrgIDConvert": "d681e6c7-0607-45b1-88a4-a19c18efb0e0", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.926+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.416+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.807+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": null }, { "OrganizationUnitID": 663, "OrganizationUnitCode": "Chi nhánh nthuong6", "OrganizationUnitName": "Chi nhánh nthuong6", "MISACode": "/000/074/", "ParentID": 653, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 0, "ApplyChild": null, "OrgIDConvert": "0acb2d29-dcbc-4ca3-bc82-afd9f1ccbf54", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.927+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.420+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.807+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": null }, { "OrganizationUnitID": 664, "OrganizationUnitCode": "CN_THSANG", "OrganizationUnitName": "CN_THSANG", "MISACode": "/000/075/", "ParentID": 653, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 0, "ApplyChild": null, "OrgIDConvert": "3d2c7400-709c-4cfc-a5fe-913eaa5910f2", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.928+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.424+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.807+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": null }, { "OrganizationUnitID": 665, "OrganizationUnitCode": "ND", "OrganizationUnitName": "Văn phòng Nam Định", "MISACode": "/000/052/", "ParentID": 653, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 0, "ApplyChild": null, "OrgIDConvert": "d8a8ee55-ceee-4be6-8e19-0df4e6849c08", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.928+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.429+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.807+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": null }, { "OrganizationUnitID": 666, "OrganizationUnitCode": "dv0002", "OrganizationUnitName": "dv0002", "MISACode": "/000/021/", "ParentID": 653, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 0, "ApplyChild": null, "OrgIDConvert": "14564ec1-9511-4609-bc19-717026d3c23d", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.928+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.433+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.807+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": null }, { "OrganizationUnitID": 667, "OrganizationUnitCode": "HNH", "OrganizationUnitName": "VP Hà Nội", "MISACode": "/000/027/", "ParentID": 653, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 0, "ApplyChild": null, "OrgIDConvert": "27898d58-0917-4c07-af4c-a197f4bf634a", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.929+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.437+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.807+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": null }, { "OrganizationUnitID": 668, "OrganizationUnitCode": "HN", "OrganizationUnitName": "VP Hà Nội", "MISACode": "/000/026/", "ParentID": 653, "Inactive": false, "HRManagementIDs": "404;412;402;277", "HRManagementNames": "Sim sim; Phạm Lê An; Nguyen Manh Duc;Mạc Duy Phương", "Standard": 0, "ApplyChild": null, "OrgIDConvert": "c31bd60d-a08f-4153-81b0-619a22f7a3e3", "IsOvertimeWithoutRequest": true, "Weekend": 2, "TenantID": "f554efba-87a1-4de2-8d8b-6f29f36cde24", "CreatedDate": "2021-01-23T10:04:23.929+07:00", "CreatedBy": "admin", "ModifiedDate": "2021-02-17T18:10:00.441+07:00", "ModifiedBy": "admin", "EditVersion": "2021-02-18T09:13:46.807+07:00", "State": 0, "OldData": null, "PassWarningCode": null, "MinimumWage": null }]
  }
};

class OrganizationApi extends BaseAPI {
  constructor() {
    super();
    this.controller = "Organizationunit";
    this.store = store;
  }

  /**
   * Hàm lấy về danh sách CCTC người dùng có quyền
   * Created by CVCUONG1 17/12/2020
   */
  async getOrganizationUnitPermission(reloadData = false, inactive = false) {
    let data = null;
    if (!inactive) {
      //Lấy dữ liệu đơn vị không chứa các đơn vị ngừng hoạt động
      if (this.store.getters.getDataOrganization && !reloadData) {
        data = this.store.getters.getDataOrganization;
      } else {
        // data = await this.get("/permission");
        data = dataFake;
        this.store.dispatch("setDataOrganization", data);
      }
      return data;
    } else {
      //Lấy dữ liệu đơn vị chứa các đơn vị ngừng hoạt động
      if (this.store.getters.getDataOrganizationInactive && !reloadData) {
        data = this.store.getters.getDataOrganizationInactive;
      } else {
        data = dataFake;
        this.store.dispatch("setDataOrganizationInactive", data);
      }
      return data;
    }
  }

  /**
   * Lấy CCTC về sử dụng control (chỉ lấy  các trường cần thiết)
   * Created by CVCUONG1 3/3/2021
   */
  async getOrganizationUnitCommon(inactive = false, reloadData = false) {
    let data = null;
    if (!inactive) {
      if (this.store.getters.getDataOrganizationCommon && !reloadData) {
        data = this.store.getters.getDataOrganizationCommon;
      } else {
        data = await this.get("/permission-common");
        this.store.dispatch("setDataOrganizationCommon", data);
      }
    }
    else {
      if (this.store.getters.getDataOrganizationCommonInactive && !reloadData) {
        data = this.store.getters.getDataOrganizationCommonInactive;
      } else {
        data = await this.get("/permission-common?inactive=true");
        this.store.dispatch("setDataOrganizationCommonInactive", data);
      }
    }
    return data;
  }

  /**
   * Hàm lấy ra danh sách CCTC dựa vào ID cha
   * Created by CVCUONG1 23/3/2021
   * @param {*} parentID danh sách ID cha
   * @param {*} inactive có lấy ra đơn vị ngừng hoạt động hay không
   */
  async getOrganizationUnitCommonById(parentID, inactive = false) {
    return await this.get(`/permission-getchild?parentID=${parentID}&&inactive=${inactive}`);
  }

  /**
   * Lấy CCTC theo id
   * CVCUONG1 6/03/2021
   * @param data thông tin người quản lý và CCTC
   */
  async getOrganizationUnitPermissionById(id) {
    return await this.get('/getorganizationunitchild/' + id);
  }

  /**
   * Hàm lưu thông tin người quản lý CCTC
   * TCDUONG 24/2/2020
   * @param data thông tin người quản lý và CCTC
   */
  async updateHRManagement(data) {
    return await this.post('/update-hrmanagement', data)
  }

  /**
  * lấy về ds cctc
  * nhviet 2021.08.24
  */
  async getAllOU() {
    let data = null;
    //Lấy dữ liệu đơn vị không chứa các đơn vị ngừng hoạt động
    if (this.store.getters.getDataOrganization) {
      data = this.store.getters.getDataOrganization;
    } else {
      data = await this.get(`/GetAllOU`);
      this.store.dispatch("setDataOrganization", data);
    }
    return data;
  }

  async getRootOU() {

    let data = null;
    //Lấy dữ liệu đơn vị không chứa các đơn vị ngừng hoạt động
    if (this.store.getters.getDataOrganization) {
      const lstOrg = this.store.getters.getDataOrganization;
      data = lstOrg.data.Data ? lstOrg.data.Data.find(x =>
        x.MISACode == '/000/'
      ) : null;
    }

    if (data) {
      return new Promise((resolve, reject) => {
        resolve({ data: { Data: [data] } });
      });
    } else {
      return await this.get(`/GetAllOU?rootOrg=true`);
    }
  }

  /**
   * lấy tất cả các vị trí công việc 
   * @returns 
   * nhviet
   */
  async getJobPosition() { 
    if (this.store.getters.getDataJobPosition) {
      const result = this.store.getters.getDataJobPosition;
      return result;
    } else {
      return new Promise((resolve, reject) => {
        this.get(`/GetJobPosition`).then(resJob => {
          resolve(resJob);
          this.store.dispatch("setDataJobPosition", resJob);
        }).catch(errJob => reject("Lấy dữ liệu chức vụ thất bại"));
      });
    } 
  }

}
export default new OrganizationApi();
